import { useState, useEffect } from "react";

import { loadIssuedIndentNumber } from "../services/issueIndentService";

const useIssuedIndentNumber = (editID) => {
    const [issuedIndentNumber, setIssuedIndentNumber] = useState([]);
    const [isMaterialCodeDataLoaded, setIsMaterialCodeDataLoaded] = useState(false);

    // Fetch department data
    const fetchIssuedIndentNumber = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadIssuedIndentNumber(para);
            if (data && data.length > 0) {
                setIssuedIndentNumber(data[0].issue_indent_number);

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCodeDataLoaded && editID === 0) {
            fetchIssuedIndentNumber();
        }
    }, [isMaterialCodeDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadIssuedIndentNumberByID = async (selectedID) => {
        await setIssuedIndentNumber(selectedID);
    };

    return {
        issuedIndentNumber,
        setIssuedIndentNumber,
        loadIssuedIndentNumberByID,
    };
};

export default useIssuedIndentNumber;
